export const NARRATIVE = 'narrative';
export const CALL_FOR_IMPACT = 'call_for_impact';
export const THINK_SEED = 'think_seed';
export const THINK_TANK = 'think_tank';
export const ELEMENT = 'element';
export const THEME_TABLE = 'theme_table';
export const USER = 'user';
export const INITIAL_CARD = 'initial_card';
export const SPEED_DATING_RANDOM = 'speed_dating_random';
export const SPEED_DATING_MEETING = 'speed_dating_meeting';
export const SPEED_DATING = 'speed_dating';
export const MEETING = 'meeting';
export const FEEDBACK_USERS = 'feedback_users';
export const FEEDBACK_TABLES = 'feedback_tables';
export const EMBED = 'embed';



// WEBPACK FOOTER //
// ./src/constants/types.js